module.exports = __webpack_public_path__ + "img/GAME_PICTURECORRECT1.c6946873.jpg";